// Google Tag Manager loader — CSP-friendly replacement for react-gtm-module.
//
// react-gtm-module injected an INLINE <script>, which forces
// `script-src 'unsafe-inline'`. Here the dataLayer bootstrap runs from our own
// bundled code (covered by `script-src 'self'`) and gtm.js is loaded as an
// EXTERNAL script from the already-allowlisted googletagmanager.com origin.
// Result: no inline script, so this does not require 'unsafe-inline'.

// Initialize the dataLayer at module import time (before ReactDOM.render and any
// component effect), so early sendGTM/dataLayer.push callers never hit an
// undefined dataLayer.
if (typeof window !== "undefined") {
  window.dataLayer = window.dataLayer || [];
}

export function initGTM(gtmId) {
  if (!gtmId || typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ "gtm.start": new Date().getTime(), event: "gtm.js" });

  // Avoid injecting the tag twice (e.g. on re-render / hot reload).
  const src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  if (document.querySelector(`script[src="${src}"]`)) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = src;
  document.head.appendChild(script);
}
